export default {
  velt: {
    openPanel: 'Buka panel komen',
    closePanel: 'Tutup panel komen',
    panel: 'Panel komen',
    tabs: 'Tab panel komen',
    comments: 'Komen',
    settings: 'Tetapan & Kebenaran',
    dragOrTapComment: 'Seret untuk menambah komen, atau ketik untuk melihat komen',
    assignComment: 'Tugaskan komen',
    markAsUnread: 'Tandai sebagai belum dibaca',
    markAsRead: 'Tandai sebagai telah dibaca',
    unsubscribe: 'Nyahlanggan',
    subscribe: 'Langgan',
    deleteThread: 'Padam benang',
    editComment: 'Edit komen',
    emptyPlaceholder: 'Berikan maklum balas, tanya soalan atau tinggalkan nota untuk ahli pasukan anda',
    searchPlaceholder: 'Cari Komen',
    commentPlaceholder: 'Komen pada {page}',
    replyPlaceholder: 'Balas....',
    filterPages: 'Halaman',
    filterAuthor: 'Pengarang',
    filterTagged: 'Ditandakan',
    statusOpen: 'Terbuka',
    statusResolved: 'Diselesaikan',
    anonymous: 'Tanpa nama',
    settingsPanel: {
      title: 'Siapa boleh memberi komen?',
      everyoneLabel: 'Semua orang',
      restrictedLabel: 'Hanya rakan kongsi yang dijemput',
      emailsLabel: 'E-mel',
      emailsPlaceholder: 'Tambah e-mel dan tekan enter',
    },
  },
}
